import React from 'react';

import { AuctionsListPage } from './pages/iframe/AuctionsListPage';

const IframeRoutes: React.FC = () => {
  return <AuctionsListPage status="prepared" />;
};

export default IframeRoutes;
